import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { Container, OpportunitiesTable, OpportunityView } from '../';
import { ButtonGroup, Button, Well, PanelGroup, Panel, Row, Col, Alert } from 'react-bootstrap';
import { Select } from 'react-select';

class OpportunitiesContainer extends React.Component {
  state = {
    show_info: true
  }
  constructor(props) {
    super(props);

    this.handleCloseInfo = this.handleCloseInfo.bind(this);
    this.handleStartCreatingOpportunity = this.handleStartCreatingOpportunity.bind(this);
    if(localStorage) {
      this.state.show_info = localStorage.getItem('opportunities-table:show_info') != 'false';
    }
  }
  handleCloseInfo() {
    this.setState({ show_info: false });
    if(localStorage) {
      localStorage.setItem('opportunities-table:show_info', 'false');
    }
  }
  handleStartCreatingOpportunity() {
    this.props.clearClient();
    this.props.startCreatingJob();
  }
  render() {
    if(this.props.params.id) {
      return (
        <Container title={'Opportunity'} addLargeWidthPadding>
          <Panel className="mb-sm adminted fadeInDown">
            <Row>
              <Col xs={12}>
                <ButtonGroup>
                  <Button onClick={e => this.props.push('/opportunities-table')} bsStyle='default'><i className='fa fa-arrow-left'></i> Back</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Panel>
          <div className="animated fadeInRight">
            <OpportunityView id={this.props.params.id} />
          </div>
        </Container>
      )
    }

    return (
      <Container style={{padding: 0}} title={'Opportunities'}>
        <Panel className='animated fadeInUp mb-none'>
          <Row>
            <Col xs={12} md={8}>
              {this.state.show_info ? <Alert className="pull-left mb-none" bsStyle='info'>
                <Button onClick={this.handleCloseInfo} className="close">x</Button>
                <b className="alert-title">New Feature!</b>
                <p>Click on a heading to filter by it.</p>
              </Alert> : null}
            </Col>
            <Col xs={12} md={4}>
              <ButtonGroup className="pull-right">
                <Button onClick={e => this.refs.table.getWrappedInstance().refresh()}><i className="fa fa-refresh"></i></Button>
                <Button onClick={this.handleStartCreatingOpportunity} bsStyle='primary'><i className='fa fa-plus'></i> Create Opportunity</Button>
              </ButtonGroup>
            </Col>
          </Row>
        </Panel>
        <OpportunitiesTable ref='table' />
      </Container>
    );
  }
}

export default connect(({jobs}) => ({...jobs}), Actions)(OpportunitiesContainer);



// WEBPACK FOOTER //
// ./src/browser/components/opportunities/opportunities-container.js